import React, { useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  TextField,
  TablePagination,
  Chip,
  IconButton,
  Tooltip
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

function SenderList({ senders, selectedSenders, onToggleSender, onToggleAll, onDeleteAllFrom }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const filteredSenders = senders.filter(sender =>
    sender.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    sender.displayName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedSenders = filteredSenders.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isAllSelected = senders.length > 0 && selectedSenders.size === senders.length;
  const isSomeSelected = selectedSenders.size > 0 && selectedSenders.size < senders.length;

  return (
    <Box>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <TextField
          label="Search senders"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setPage(0);
          }}
          sx={{ width: 300 }}
        />
        <Box>
          <Chip
            label={`${selectedSenders.size} of ${senders.length} selected`}
            color="primary"
            sx={{ mr: 2 }}
          />
          <Chip
            label={`${senders.length - selectedSenders.size} will be filtered`}
            color="warning"
          />
        </Box>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={isAllSelected}
                  indeterminate={isSomeSelected}
                  onChange={(e) => onToggleAll(e.target.checked)}
                />
              </TableCell>
              <TableCell><strong>Display Name</strong></TableCell>
              <TableCell><strong>Email</strong></TableCell>
              <TableCell align="right"><strong>Email Count</strong></TableCell>
              <TableCell align="center"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedSenders.map((sender) => (
              <TableRow
                key={sender.email}
                hover
              >
                <TableCell padding="checkbox" onClick={() => onToggleSender(sender.email)} sx={{ cursor: 'pointer' }}>
                  <Checkbox checked={selectedSenders.has(sender.email)} />
                </TableCell>
                <TableCell onClick={() => onToggleSender(sender.email)} sx={{ cursor: 'pointer' }}>{sender.displayName}</TableCell>
                <TableCell onClick={() => onToggleSender(sender.email)} sx={{ cursor: 'pointer' }}>{sender.email}</TableCell>
                <TableCell align="right" onClick={() => onToggleSender(sender.email)} sx={{ cursor: 'pointer' }}>{sender.count}</TableCell>
                <TableCell align="center">
                  <Tooltip title="Delete all emails from this sender">
                    <IconButton
                      color="error"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteAllFrom(sender.email, sender.displayName);
                      }}
                    >
                      <DeleteForeverIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={filteredSenders.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
        />
      </TableContainer>
    </Box>
  );
}

export default SenderList;
